import { render } from "./OurFacilities.vue?vue&type=template&id=6596d6ac&scoped=true"
import script from "./OurFacilities.vue?vue&type=script&lang=ts"
export * from "./OurFacilities.vue?vue&type=script&lang=ts"

import "./OurFacilities.vue?vue&type=style&index=0&id=6596d6ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6596d6ac"

export default script